/**
 * Blog configuration constants
 */

/** Maximum title length (SEO best practice: under 60 for Google) */
export const MAX_TITLE_LENGTH = 70

/** Maximum description length (SEO meta description: 155-160 chars) */
export const MAX_DESCRIPTION_LENGTH = 160

/** Maximum number of tags allowed per blog post */
export const MAX_TAGS_PER_POST = 3

/** Maximum number of tags to display in the blog page filter */
export const MAX_TAGS_DISPLAY = 6

/**
 * Allowed tags for blog posts.
 * Use these tags to maintain consistency across posts.
 * New tags should be added here after team discussion.
 */
export const ALLOWED_TAGS = [
  // Content types
  'tutorial',
  'guide',
  'comparison',
  'announcement',
  'case-study',

  // Topics
  'database',
  'postgres',
  'api',
  'ai',
  'edge',
  'performance',

  // Technologies
  'nodejs',
  'typescript',
  'react',

  // Actions
  'migration',
  'deployment',
] as const

export type AllowedTag = typeof ALLOWED_TAGS[number]

/**
 * Validates that all tags are from the allowed list.
 * Returns invalid tags if any are found.
 */
export function validateTags(tags: string[]): { valid: boolean; invalidTags: string[] } {
  const invalidTags = tags.filter(tag => !ALLOWED_TAGS.includes(tag as AllowedTag))
  return {
    valid: invalidTags.length === 0,
    invalidTags,
  }
}
